import AbstractValidator from './AbstractValidator';

export default class LessThan extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        notLessThanInclusive: 'Die Eingabe (%value%) ist nicht kleiner oder gleich %referenceValue%.',
        notLessThan: 'Die Eingabe (%value%) ist nicht kleiner als %referenceValue%.',
    };

    run()
    {
        let key       = this._options.key;
        let inclusive = !!this._options.inclusive;

        if (key)
        {
            this._options.referenceValue = parseInt(this.context[key]);

            if (inclusive && (parseInt(this.value) > this._options.referenceValue))
            {
                this.error = this.getMessage('notLessThanInclusive');
            }
            else if (!inclusive && (parseInt(this.value) >= this._options.referenceValue))
            {
                this.error = this.getMessage('notLessThan');
            }
        }

        this._options.referenceValue = this._options.max;

        if (inclusive && this.value > this._options.referenceValue)
        {
            this.error = this.getMessage('notLessThanInclusive');
        }
        else if (!inclusive && this.value >= this._options.referenceValue)
        {
            this.error = this.getMessage('notLessThan');
        }
    }
}